export const queryKeys = {
  currentUser: ['auth', 'me'] as const,
  health: ['health'] as const,
  publicProducts: ['public', 'products'] as const,
  publicProduct: (slug: string) => ['public', 'products', slug] as const,
  publicFaq: ['public', 'faq'] as const,
  products: (filters: Record<string, unknown> = {}) => ['products', filters] as const,
  product: (id: string) => ['products', 'detail', id] as const,
  faq: ['faq'] as const
};
